import { AssetsService } from "app/services/AssetsService";
import { StyledProfilesEmptyState, StyledImage } from "./styles";

type EmployeeProfilesEmptyStateProps = {
    onDismiss(): void;
};

const EmployeeProfilesEmptyState = ({ onDismiss }: EmployeeProfilesEmptyStateProps) => {
    return (
        <StyledProfilesEmptyState
            image={
                <StyledImage
                    src={AssetsService.assetUrl("images/sales-intelligence/profiles.svg")}
                    alt="profiles"
                />
            }
            steps={[
                { key: "si.contacts-search-profiles.empty.step.define" },
                { key: "si.contacts-search-profiles.empty.step.name_it" },
                {
                    key: "si.contacts-search-profiles.empty.step.get",
                },
            ]}
            onDismiss={onDismiss}
            titleI18nKey="si.contacts-search-profiles.empty.title"
            subtitleI18nKey="si.contacts-search-profiles.empty.subtitle"
        />
    );
}

export default EmployeeProfilesEmptyState;
